/**
 * Created by Administrador on 20/07/2019.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('disembarkationCtrl', disembarkationCtrl);

    disembarkationCtrl.$inject = ['$stateParams', 'tabs', 'datePickerService', 'flightService',
        'linkService','cargoReportService','branchOffices'];

    function disembarkationCtrl($stateParams, tabs, datePickerService, flightService, linkService, cargoReportService,branchOffices){
        var vm = this;

        vm.linkService = linkService;
        vm.tabs = tabs;
        vm.flights = [];
        vm.branchOffices = branchOffices.data._embedded ? branchOffices.data._embedded.branchOffices: [];
        vm.report = undefined;
        vm.departureDate = new Date();
        vm.filterPaperSize =
            {
                "normal" : true
            }

        vm.dateParam = $stateParams.date;
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.eventChangeDepartureDate = function(){
            vm.report = undefined;
            if(vm.departureDate != undefined && vm.branchOffice != undefined){
                vm.flights= [];
                flightService.getFlightByDepartureDateAndOriginDestiny(vm.departureDate.getTime(),linkService.getLinkId(vm.branchOffice._embeddeds.airport._links.self.href))
                    .then(function (response) {
                        angular.forEach(response, function(flight){
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                flightId: linkService.getLinkId(flight._links.self.href),
                                route: flight._embedded.route.initials,
                                departureFlightId: linkService.getLinkId(flight._embedded.departureflights[0]._links.self.href)
                            });
                        });
                    });
            }
        }

        vm.onChangeReport = function(){
            vm.report = undefined;
        }

        vm.exportPdf = function(reducedPrint){
            cargoReportService.getDisembarkationPdf(vm.linkService.getLinkId(vm.branchOffice._links.self.href),
                vm.flight.flightId,vm.flight.departureFlightId,reducedPrint)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "Reporte_Desembarque_"+(reducedPrint?"Reducido":"Normal")+".pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.getReport = function(){
            if(vm.flight != undefined && vm.branchOffice != undefined){
                cargoReportService.getDisembarkation(vm.linkService.getLinkId(vm.branchOffice._links.self.href),
                    vm.flight.flightId,vm.flight.departureFlightId)
                    .then(function (response) {
                        if(response == undefined){
                            vm.report = undefined;
                        }else{
                            vm.report = response.data;
                        }
                    });
            }
        }

        vm.cancel = function() {
            linkService.reloadRoute(linkService.getCurrentRouteName(), {})
        };
    }
})();
